import { render, staticRenderFns } from "./ContactBankDetails.vue?vue&type=template&id=0aef87da"
import script from "./ContactBankDetails.vue?vue&type=script&lang=js"
export * from "./ContactBankDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports